import React, { FC, memo } from 'react';
import classNames from 'classnames';
import { Bubble } from 'tea-component';
import defaultKol from '@/pages/intelligence/assets/svg/tipicon/kol-default.svg';
import {
  getAuthorDepartment,
  getAuthorDisplayName,
  type IReportAuthorViewModel,
} from '../authors';

import './index.scss';

interface ICreatorBox {
  authors: IReportAuthorViewModel[];
  lang?: number;
  showContactInfo?: boolean;
  onCopyIconClick?: (email: string) => void;
}

type TAuthorListDensity = 'spacious' | 'regular' | 'compact';

const getAuthorListDensity = (count: number): TAuthorListDensity => {
  if (count >= 3) return 'compact';
  if (count === 2) return 'regular';
  return 'spacious';
};

const CreatorBox: FC<ICreatorBox> = (props) => {
  const { authors, lang = 0 } = props;
  const density = getAuthorListDensity(authors.length);

  return (
    <div
      className={classNames('reports-author-list', {
        'reports-author-list--spacious': density === 'spacious',
        'reports-author-list--regular': density === 'regular',
        'reports-author-list--compact': density === 'compact',
      })}
    >
      {authors.map((author) => {
        const displayName = getAuthorDisplayName(author, lang);
        const department = getAuthorDepartment(author, lang);
        const avatar = author.avatar || defaultKol;
        return (
          <Bubble
            key={author.key}
            dark
            trigger="hover"
            placement="top"
            className="reports-author-bubble-container"
            content={
              <div className="reports-author-bubble">
                <div className="reports-author-bubble-header">
                  <img src={avatar} alt="" />
                  <strong>{displayName}</strong>
                </div>
                <div className="reports-author-bubble-department">
                  {department}
                </div>
              </div>
            }
          >
            <div className="reports-author-info">
              {(!author.isDatasourceAvatar || author.avatar) && (
                <div
                  className={`reports-author-info-head${
                    author.isDatasourceAvatar
                      ? ' reports-author-info-head--datasource'
                      : ''
                  }`}
                >
                  <img src={avatar} alt="" loading="lazy" />
                </div>
              )}
              <div
                className={`reports-author-info-right${
                  author.isDatasourceAvatar
                    ? ' reports-author-info-right--datasource'
                    : ''
                }`}
              >
                <div className="reports-author-name-contact">
                  <span className="reports-author-name">{displayName}</span>
                </div>
                <span className="reports-author-department">{department}</span>
              </div>
            </div>
          </Bubble>
        );
      })}
    </div>
  );
};

CreatorBox.displayName = 'Author';
export default memo(CreatorBox);
